import React from 'react';
import PropTypes from 'prop-types';

const LogoBig = ({ isLoading = false }) => {
    return (
        <svg width={186.123} height={165.3} viewBox="0 0 186.123 165.3">
            <defs>
                <style>{'.prefix__a{fill:#fff}'}</style>
            </defs>
            <path
                className="prefix__a"
                d="M58.516 137.199l33.339-33.339a3.609 3.609 0 000-5.058L76.794 83.743a3.608 3.608 0 00-5.058 0l-13.22 13.221a3.608 3.608 0 01-5.059 0l-12.3-12.3a3.607 3.607 0 010-5.058l68.632-68.632a3.506 3.506 0 00-.345-5.288A28.4 28.4 0 0072.311 8.33l-53.572 53.8-.115-.115L1.035 79.603a3.608 3.608 0 000 5.058"
            />
            <path
                className="prefix__a"
                d="M132.666 68.452l12.3 12.3a3.609 3.609 0 010 5.058l-68.747 68.517a3.506 3.506 0 00.345 5.288 28.4 28.4 0 0037.133-2.644l53.687-53.69.115.115 17.585-17.584a3.607 3.607 0 000-5.058l-52.537-52.538a3.608 3.608 0 00-5.058 0L94.154 61.555a3.608 3.608 0 000 5.058l15.06 15.06a3.608 3.608 0 005.059 0l13.22-13.221a3.748 3.748 0 015.173 0z"
            />
            {isLoading && (
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    from="0 0 0"
                    to="360 0 0"
                    dur="1s"
                    repeatCount="indefinite"
                />
            )}
        </svg>
    );
};

LogoBig.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

export default LogoBig;
